import {useEffect, useState} from 'react'

export function useDidMount() {
  const [mount, setMount] = useState(false)
  useEffect(() => {
    setMount(true)
  }, [])
  return mount
}
